<div class="data-filter" *ngFor="let item of optionalAmountControls">
    <label >{{ item?.value?.charge_code}}</label>
    <input type="text" class="form-control" 
    [i18n]="[{target: 'attribute:placeholder', key: 'df-management.form.placeholder.placeholder-message'}]"
    validateNumber="9.3" [readonly]="chargeCodeValidate[item?.value?.charge_code]"
    [formControl]="item.get('charge_amount')">
    <span class="errormsg"  *ngIf="(item.get('charge_amount').touched || 
    item.get('charge_amount').dirty) && 
    item.get('charge_amount').errors">
        <span [i18n]="'df-management.form.message.error-message'"></span>
    </span>
</div>